import * as XLSX from 'xlsx'
import { ColDef } from 'ag-grid-community'

export const exportAsXls = (
  columnDefs: ColDef[],
  rowData: any[],
  collection: string
) => {
  let columns: ColDef[] = []

  // Filter and collect visible columns
  columnDefs
    .filter((col) => !col.hide && col.field && col.field !== 'attachment')
    .forEach((col) => {
      if ((col as any).children) {
        columns = columns.concat((col as any).children)
      } else {
        columns.push(col)
      }
    })

  columns = columns.filter((col) => !col.hide && col.field)

  // Transform row data
  const data = rowData.map((row) => {
    const value: any = {}
    columns.forEach((col) => {
      if (!col.field) return

      let x: any = row
      const keys: string[] = col.field.split('.')
      keys.forEach((key) => {
        if (x) x = x[key]
        else x = null
      })

      // Apply value formatter if exists
      if (col.valueFormatter && typeof col.valueFormatter === 'function') {
        x = col.valueFormatter({ value: x, data: row } as any)
      }

      // Handle object values
      if (typeof x === 'object' && x !== null) {
        x = JSON.stringify(x)
      }

      value[col.headerName || col.field] = x ?? ''
    })
    return value
  })

  // Create workbook and worksheet
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data)
  const workbook: XLSX.WorkBook = {
    Sheets: { data: worksheet },
    SheetNames: ['data'],
  }

  // Write file
  const fileName = `${collection}.xlsx`
  XLSX.writeFile(workbook, fileName)
}


